export const MAPPINGS = {
    PS: [
        '↑',
        '↓',
        '←',
        '→',
        '✖',
        '●',
        '■',
        '▲',
        'R1',
        'L1',
        'R2',
        'L2',
        'R3',
        'L3',
        'OPTION',
        'TOUCHPAD',
        'HOME',
    ],
    XB: [
        '↑',
        '↓',
        '←',
        '→',
        'A',
        'B',
        'X',
        'Y',
        'RB',
        'LB',
        'RT',
        'LT',
        'R3',
        'L3',
        'START',
        'SELECT',
        'HOME',
    ],
    NS: [
        '↑',
        '↓',
        '←',
        '→',
        'B',
        'A',
        'Y',
        'X',
        'RB',
        'LB',
        'RT',
        'LT',
        'R3',
        'L3',
        'START',
        'SELECT',
        'HOME',
    ],
}